export default __webpack_public_path__ + "static/screenshot-actions-dac6ffac00ffa58fff0ed63bf68a5d79.webp";